import Reveal from "./Reveal";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[color:var(--sr-black)] py-24 lg:py-32"
      aria-label="Meet LaCretia"
    >
      <div className="max-w-[1300px] mx-auto px-6 lg:px-12 grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.2fr)] gap-14 lg:gap-24 items-center">
        {/* Arched portrait */}
        <Reveal variant="left" className="mx-auto lg:mx-0 w-full max-w-[440px]">
          <div className="arched aspect-[3/4] bg-[color:var(--sr-cream)]">
            <img
              src="/images/lacretia-headshot.jpg"
              alt="LaCretia Wheeler — owner and licensed esthetician at Skin Refinery"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="mt-6 text-center lg:text-left eyebrow text-[color:var(--sr-beige)]">
            LaCretia Wheeler &middot; Missouri Licensed Esthetician
          </p>
        </Reveal>

        {/* Right content */}
        <div>
          <Reveal>
            <p className="eyebrow">Meet LaCretia</p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] text-[color:var(--sr-ivory)] mt-4 tracking-[-0.01em]">
              Hi, I&rsquo;m LaCretia.
            </h2>
          </Reveal>
          <Reveal delay={160}>
            <p className="mt-8 text-[color:var(--sr-beige)] text-[15.5px] leading-[1.9] max-w-[600px]">
              I&rsquo;m the owner of Skin Refinery. My passion is helping
              clients feel confident by refining their natural beauty through
              customized skincare, Korean lash lifts, brow services, and
              results-driven treatments. I believe every service should be
              tailored to your unique features and goals because no two clients
              are the same.
            </p>
          </Reveal>
          <Reveal delay={220}>
            <p className="mt-6 text-[color:var(--sr-beige)] text-[15.5px] leading-[1.9] max-w-[600px]">
              When you visit Skin Refinery, my goal is for you to feel relaxed,
              cared for, and confident in the results. I&rsquo;m committed to
              continuing my education and bringing the latest techniques to
              every appointment so you can always expect exceptional care from
              the moment you walk through the door.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
